module.exports = "<app-layout-header></app-layout-header>\n<div class=\"container wb-container\">\n    <router-outlet></router-outlet>\n</div>\n<app-layout-footer></app-layout-footer>\n<toaster-container [toasterconfig]=\"toasterConfig\"></toaster-container>\n<app-upload-assets-widget></app-upload-assets-widget>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main